// PreFooter.js

function PreFooter() {
  return (
    <section className="pre-footer">
      <div className="pre-footer-content">

        <div className="footer-col">
          <h3 style={{ fontFamily: "'Playfair Display', serif" }}>
            Media &amp; Community Relations Centre
          </h3>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>University of Peradeniya</p>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>P.O. Box 20400</p>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>Peradeniya, Sri Lanka</p>
        </div>

        <div className="footer-col">
          <h4 style={{ fontFamily: "'Playfair Display', serif" }}>Quick Links</h4>
          <ul style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>
            <li><a href="#home">Home</a></li>
            <li><a href="#about">About Us</a></li>
            <li><a href="#services">Our Services</a></li>
            <li><a href="#contact">Contact</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h4 style={{ fontFamily: "'Playfair Display', serif" }}>Contact</h4>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>
            Email: <a href="mailto:mcrc@gs.pdn.ac.lk">mcrc@gs.pdn.ac.lk</a>
          </p>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>Phone: +94 81 239 2329</p>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif" }}>Ext: 2329</p>
          <p style={{ fontFamily: "'Source Sans 3', 'Segoe UI', sans-serif", marginTop: "10px" }}>
            Alternative: <a href="mailto:webmaster@pdn.ac.lk">webmaster@pdn.ac.lk</a>
          </p>
        </div>

        <div className="footer-col">
          <h4 style={{ fontFamily: "'Playfair Display', serif" }}>Follow Us</h4>
          <div className="social-links">
            <a href="/" className="social-icon" aria-label="Facebook">f</a>
            <a href="/" className="social-icon" aria-label="Instagram">&#128247;</a>
            <a href="/" className="social-icon" aria-label="LinkedIn">in</a>
            <a href="/" className="social-icon" aria-label="YouTube">&#9654;</a>
          </div>
        </div>

      </div>
    </section>
  );
}

export default PreFooter;